import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from 'i18n';

type InstructionStep = { title: string; description: string };

type Props = {
  bank?: string;
  customerBank?: string;
  country?: string;
  amount: number | string;
  currencySymbol: string;
  isDeeplinkSberbank?: boolean;
  isMobileOperator?: boolean;
  isQrMode?: boolean;
};

export const SqInstructionSteps: React.FC<Props> = ({
  bank,
  customerBank,
  country,
  amount,
  currencySymbol,
  isDeeplinkSberbank,
  isMobileOperator,
  isQrMode,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_details',
  });

  const stepsKey = useMemo(
    () =>
      isDeeplinkSberbank
        ? 'rules_deeplink_sberbank.steps'
        : isMobileOperator
        ? 'rules_sim.steps'
        : isQrMode
        ? 'instruction_qr.steps'
        : 'instruction_basic.steps',
    [isDeeplinkSberbank, isMobileOperator, isQrMode],
  );

  const steps = t(stepsKey, {
    returnObjects: true,
    bank,
    customerBank,
    country,
    amount: `${amount} ${currencySymbol}`,
  }) as InstructionStep[];

  if (!Array.isArray(steps)) {
    return null;
  }

  return (
    <ol className="tw-list-none tw-m-0 tw-p-0 tw-flex tw-flex-col tw-gap-4">
      {steps.map((step, index) => (
        <li key={index} className="tw-flex tw-gap-3">
          <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-blue-500 tw-text-white tw-text-xs tw-font-medium tw-shrink-0 tw-mt-0.5">
            {index + 1}
          </span>
          <div>
            <div className="tw-font-semibold tw-text-sm tw-text-primary">
              {step.title}
            </div>
            <div className="tw-text-sm tw-text-secondary tw-mt-0.5">
              {step.description}
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
};
